import axios from "axios";

export const baseUrl =
  process.env.REACT_APP_BASE_URL || "https://dev.api.peerlesslms.com/api/v1";

// Turns an axios failure into "PATCH /auth/users/x/ -> 403: You do not have
// permission to perform this action" so a failing call identifies itself.
export const describeApiError = (error) => {
  const config = error?.config || {};
  const response = error?.response;
  const method = (config.method || "get").toUpperCase();
  const url = config.url || "unknown endpoint";

  if (!response) return `${method} ${url} -> no response (${error?.message})`;

  const body = response.data;
  const detail =
    body?.detail ||
    (typeof body === "string" ? body : JSON.stringify(body ?? {}));

  return `${method} ${url} -> ${response.status}: ${detail}`;
};

// Uploaded files come back as relative paths ("/company/banner/x.png") with no
// host attached, and they are not served from the /api/v1 prefix. Point
// REACT_APP_MEDIA_URL at whatever actually serves them if the default is wrong.
export const mediaBaseUrl =
  process.env.REACT_APP_MEDIA_URL || baseUrl.replace(/\/api\/v1\/?$/, "");

export const mediaUrl = (path) => {
  if (!path || typeof path !== "string") return null;
  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) return path;
  return `${mediaBaseUrl}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const sendRequest = (
  endpoint,
  data = {},
  method = "GET",
  contentType = "application/json",
) => {
  return axios({
    url: `${baseUrl}${endpoint}`,
    method: method,
    data: data,
    headers: {
      Accept: "application/json",
      "Content-type": contentType,
      Authorization: localStorage.getItem("access")
        ? `Bearer ${localStorage.getItem("access")}`
        : "",
    },
  }).catch((error) => {
    console.error(`[api] ${describeApiError(error)}`);
    throw error;
  });
};
